import moment from 'moment';

/**
 * Formata uma data para exibição em células de tabela
 * @param {string|Date|null|undefined} date - Data a ser formatada
 * @param {string} format - Formato desejado (padrão: 'DD/MM/YYYY HH:mm')
 * @param {string} fallback - Valor a retornar se a data for inválida (padrão: '-')
 * @returns {string} Data formatada ou fallback
 */
export function formatDateCell(date, format = 'DD/MM/YYYY HH:mm', fallback = '-') {
  if (!date) {
    return fallback;
  }
  
  try {
    const momentDate = moment(date);
    
    if (!momentDate.isValid()) {
      return fallback;
    }
    
    return momentDate.format(format);
  } catch (error) {
    console.warn('Erro ao formatar data:', error);
    return fallback;
  }
}

/**
 * Formata uma data para exibição simples (apenas data)
 * @param {string|Date|null|undefined} date - Data a ser formatada
 * @returns {string} Data formatada ou '-'
 */
export function formatDateOnly(date) {
  return formatDateCell(date, 'DD/MM/YYYY');
}

/**
 * Formata uma data para exibição com hora
 * @param {string|Date|null|undefined} date - Data a ser formatada
 * @returns {string} Data formatada ou '-'
 */
export function formatDateTime(date) {
  return formatDateCell(date, 'DD/MM/YYYY HH:mm');
}

